const CarosuelButton: React.CSSProperties = {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 2,
    background: '#fff',
    border: '1px solid #ccc',
    width: 32,
    height: 32,
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}

export const CarouselLButton: React.CSSProperties = {
    ...CarosuelButton,
    left: '40px',
};

export const CarouselRButton: React.CSSProperties = {
    ...CarosuelButton,
    right: `${40 + 32}px`,
};
